<template>
  <v-btn icon @click="toggleFullScreen" class="hidden-sm-and-down">
    <v-icon>fullscreen</v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: "FullScreen",
    methods: {
      toggleFullScreen() {
        const document = window.document;
        const documentElement = document.documentElement;
        const requestFullScreen =
          documentElement.requestFullscreen ||
          documentElement.mozRequestFullScreen ||
          documentElement.webkitRequestFullScreen ||
          documentElement.msRequestFullscreen;
        const cancelFullScreen =
          document.exitFullscreen ||
          document.mozCancelFullScreen ||
          document.webkitExitFullscreen ||
          document.msExitFullscreen;
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
          ? requestFullScreen.call(documentElement)
          : cancelFullScreen.call(documentElement);
      }
    }
  }
</script>

<style scoped>

</style>